// 生产环境配置 - 前后端使用相同域名
export const productionConfig = {
  api: {
    baseURL: '/', // 使用相对路径，前后端同域名
    version: 'v1',
    path: '/api',
    timeout: 15000, // 生产环境可能需要更长的超时时间
  },
  env: 'production',
}; 